import * as React from "react";
import { Button } from "@/components/ui/button";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { useUpdateBusinessReportOutcomeMutation } from "@/modules/snapshots/businessReports.api";
import TopBarProgress from "react-topbar-progress-indicator";
import { toast } from "react-toastify";

interface Props {
  businessReportOutcome: BusinessReportOutcome;
  readOnly?: boolean;
}

export const SnapshotGridTableRowVerified: React.FC<Props> = ({ businessReportOutcome, readOnly = false }) => {
  const [updateBusinessReportOutcome, { isLoading }] = useUpdateBusinessReportOutcomeMutation();
  const handleClick = async () => {
    const next = businessReportOutcome.verified ? "unverified" : "verified";
    try {
      await updateBusinessReportOutcome({
        id: businessReportOutcome.id,
        data: { verified: !businessReportOutcome.verified },
      }).unwrap();
      toast.success(`Snapshot marked as ${next}`);
    } catch {
      toast.error(`Snapshot could not be marked as ${next}`);
    }
  };

  return (
    <>
      {isLoading && <TopBarProgress />}
      {businessReportOutcome.verified ? (
        <Button
          size="xs"
          onClick={() => void handleClick()}
          disabled={readOnly}
          className="bg-green-600 text-left"
          style={{ width: 100 }}
        >
          Verified
        </Button>
      ) : (
        <Button
          size="xs"
          onClick={() => void handleClick()}
          disabled={readOnly}
          className="bg-amber-500"
          style={{ width: 100 }}
        >
          Unverified
        </Button>
      )}
    </>
  );
};
